/**
 * Clean and normalize phone number
 * @param {string} phone 
 * @returns {string} digits only
 */
export const normalizePhone = (phone) => {
  if (!phone) return '';
  return phone.replace(/\D/g, '');
};

/**
 * Format phone for display (e.g., 081-234-5678)
 * @param {string} phone 
 * @returns {string} formatted phone
 */
export const formatPhoneDisplay = (phone) => {
  const cleaned = normalizePhone(phone);
  if (cleaned.length === 10 && cleaned.startsWith('0')) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  if (cleaned.length === 11 && cleaned.startsWith('66')) {
    return `+66 ${cleaned.slice(2, 4)}-${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  return phone;
};

/**
 * Get array of phone formats for searching in DB
 * Handles both 0xx... and 66xx... formats
 * @param {string} phone 
 * @returns {string[]} array of possible phone formats
 */
export const getPhoneSearchFormats = (phone) => {
  const cleaned = normalizePhone(phone);
  if (!cleaned) return [];
  
  const formats = [cleaned];
  
  if (cleaned.startsWith('0') && cleaned.length === 10) {
    formats.push('66' + cleaned.substring(1));
  } else if (cleaned.startsWith('66') && cleaned.length === 11) {
    formats.push('0' + cleaned.substring(2));
  }
  
  return formats;
};
